import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const DatabaseManagement = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-100 py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <div className="flex justify-between items-center">
                        <h1 className="text-3xl font-bold text-gray-900">مزامنة قاعدة البيانات</h1>
                        <button
                            onClick={() => navigate('/')}
                            className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg transition-colors"
                        >
                            <ArrowRight className="w-5 h-5" />
                            العودة للرئيسية
                        </button>
                    </div>
                </div>
                <div className="bg-white rounded-lg shadow-md p-6">
                    <p className="text-gray-500">هذه الميزة قيد التطوير...</p>
                </div>
            </div>
        </div>
    );
};

export default DatabaseManagement;